// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Table } from 'react-bootstrap'
import { Message } from '../components/message'
import { evalDateHour } from '../utils/enUtils.js'

export class ActivityTable extends Component {
    loadTableData() {
        if (this.props.results.length === 0) {
            return (
                <Message
                    text={"You don't have any " + this.props.title}
                />
            )
        }

        return (
            <div>
                <h4>{this.props.title}</h4>
                <Table responsive>
                    {this.loadHeader()}
                    {this.loadRows()}
                </Table>
            </div>
        )
    }

    loadHeader() {
        return (
            <thead>
                <tr>
                    <th>Session</th>
                    <th>Scenario</th>
                    <th>Date Played</th>
                    <th>Score</th>
                    <th>Communication</th>
                    <th>Customer Service</th>
                </tr>
            </thead>
        )
    }

    evalPoints(value, total) {
        if (total === 0) {
            return "N/A"
        }
        else {
            return value + "/" + total
        }
    }

    evalStrikes(value, total) {
        if (total === 0) {
            return "N/A"
        }
        else if (value <= 0) {
            return "Excellent (0 strikes)"
        }
        else if (value <= 1) {
            return "Good (1 strike)"
        }
        else if (value <= 2) {
            return "Pass (2 strikes)"
        }
        else {
            return <b style={{ color: '#E9573F' }}>Fail (3 strikes)</b>
        }
    }

    evalComms(value, total) {
        var frac = value / total

        if (total === 0) {
            return "N/A"
        }
        else if (frac >= 0.8) {
            return "Excellent"
        }
        else if (frac >= 0.2) {
            return "Good"
        }
        else if (frac >= 0.0) {
            return "Satisfactory"
        }
        else {
            return "Poor"
        }
    }

    evalService(value, total) {
        var frac = value / total
        var resultText = " (" + value + "/" + total + ")"

        if (total === 0) {
            return "N/A"
        }
        else if (frac >= 0.8) {
            return "Excellent" + resultText
        }
        else if (frac >= 0.6) {
            return "Good" + resultText
        }
        else if (frac >= 0.4) {
            return "Satisfactory" + resultText
        }
        else {
            return "Poor" + resultText
        }
    }

    loadRows() {
        let dataRows = this.props.results.map((result, index) => {
            let createdDate = new Date(result.created_at)
            let strikePoints = this.evalStrikes(result.tracking_data.number_of_strikes, 3)
            let commPoints = this.evalComms(result.tracking_data.communication_points, result.tracking_data.total_communication_points)
            let servicePoints = this.evalPoints(result.tracking_data.service_points, result.tracking_data.total_service_points)

            return (
                <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{result.scenario_name}</td>
                    <td>{evalDateHour(createdDate)}</td>
                    <td>{strikePoints}</td>
                    <td>{commPoints}</td>
                    <td>{servicePoints}</td>
                </tr>
            )
        })

        return (
            <tbody>
                {dataRows}
            </tbody>

        )
    }

    render() {
        return (
            this.loadTableData()
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/activityTable.js